module.exports = __webpack_public_path__ + "img/浙江省.117a7387.png";